
  document.addEventListener('DOMContentLoaded', function() {
    var allLinks = document.querySelectorAll('a');
    allLinks.forEach(function(link) {
      if (link.href.startsWith('https://api.whatsapp')) {
        link.setAttribute('target', '_blank');
      }
    });

    var sidebar = document.querySelector('.institutional-no-sidebar');
    if (!sidebar) return;
    var lastScrollTop = 0;
    var initialOffset = sidebar.offsetTop;
    var ticking = false;

    function onScroll() {
      var scrollTop = window.scrollY;

      if (scrollTop > initialOffset) {
        sidebar.classList.add('fixed');
      } else {
        sidebar.classList.remove('fixed');
      }

      if (scrollTop < lastScrollTop) {
        sidebar.style.top = '40px';
      } else {
        sidebar.style.top = '40px';
      }

      lastScrollTop = scrollTop;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    });


  });

 
  
